import React, { ReactElement } from 'react';

export default function Residential(props: {
    className?: string;
}): ReactElement {
    const { className } = props;

    return (
        <svg className={className} fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'>
            <path d='M20 9V21.5H4V9' stroke='currentColor' />
            <path d='M8.5 13.5H15.5V21.5H8.5V13.5Z' stroke='currentColor' />
            <path d='M2 10L11.4855 4.3087C11.8022 4.11869 12.1978 4.11869 12.5145 4.3087L22 10' stroke='currentColor' strokeLinecap='round' />
            <rect fill='currentColor' height='2' rx='0.5' width='1' x='13' y='16' />
            <path clipRule='evenodd' d='M16.5 4.5H19.5V8H18.5V5.5H17.5V7.5L16.5 6.5V4.5Z' fill='currentColor' fillRule='evenodd' />
        </svg>
    );
}